import { Injectable } from '@angular/core';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';


@Injectable({
  providedIn: 'root'
})
export class UploadDocumentService {

  customer;
  sessionToken;
 
  constructor(
  
    private userSession: UserSessionService ,
    private webservice: WebservicesService
) {      
    
    this.userSession.getCustomer().subscribe(
        (customer) => {
          this.customer = customer;
          this.sessionToken = this.userSession.getSessionToken();
        }
      );
}

/**
 * POST - upload file
 */
public callUploadFile(obj: FormData){
    obj.append('customer_id',this.customer.customerId);
    obj.append('session_token',this.userSession.sessionToken);

    return this.webservice.postFormData('external/files', obj);
}

/**
 * POST - upload file
 */
public uploadKycFile(obj: FormData){
    return this.webservice.postFormData('external/files', obj);
}

public callSecureUploadDocumentFile(obj: FormData){
  return this.webservice.postFormData('external/save-documents', obj);
}
}